import { BankAccountsContext } from '@app/collections/fortress/BankAccountsContext'
import { Button, Col, Collapse, CollapsePanel, Divider, Notification, Row, Select, Spacer, Text } from '@app/components'
import { DynamicForm, generateDynamicFields } from '@app/modules'
import { IStore } from '@app/redux'
import { auth, errorHandler, getSingle } from '@app/services'
import axios from 'axios'
import { ADD_NEW_AU_FORM, ADD_NEW_CA_FORM, ADD_NEW_EU_FORM, ADD_NEW_UK_FORM } from 'libs/data/forms/AddNewACH.form'
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { BankIcon } from '~public'

import { CustomSelect } from './custom-select'

export const IntlTransfer: React.FC<any> = ({ form, selectedMethod, setSelectedMethod }) => {
  const { ogbAccounts, fetchAccounts } = useContext(BankAccountsContext)
  const [activeKey, setActiveKey] = useState(null)
  const [transactionType, setTransactionType] = useState('EU-instructions')

  useEffect(() => {
    fetchAccounts()
    getSingleCountry()
  }, [])

  const getSingleCountry = async () => {
    const single = await getSingle(user.uid)
    setTransactionType(
      single?.country
        ? single.country == 'AU'
          ? 'AU-instructions'
          : single.country == 'CA'
            ? 'CA-instructions'
            : single.country == 'UK'
              ? 'UK-instructions'
              : 'EU-instructions'
        : 'EU-instructions',
    )
  }

  const getCountryForm = () => {
    switch (transactionType) {
      case 'EU-instructions':
        return ADD_NEW_EU_FORM
      case 'AU-instructions':
        return ADD_NEW_AU_FORM
      case 'CA-instructions':
        return ADD_NEW_CA_FORM
      case 'UK-instructions':
        return ADD_NEW_UK_FORM
      default:
        return ADD_NEW_EU_FORM
    }
  }

  const handleCollapseChange = (key) => {
    setActiveKey(key)
  }

  const { user } = useSelector((state: IStore) => state)

  const onACHSubmit = async (key) => {
    try {
      const data = await form.validateFields()
      data.identityId = user.selectedEntityName ? user.selectedEntityIdentityId : null
      data.transactionType = transactionType

      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      await axios.post('/api/north-one/manual-local', data, { headers })
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to add local account manually: ${error}`
    } finally {
      handleCollapseChange(key)
      await fetchAccounts()
      //setSelectedMethod()
    }
  }

  /**
   * It takes the `accounts` array, maps over it, and returns an array of objects with the following
   * properties: `id`, `title`, `icon`, and `description`
   * @returns An array of objects.
   */
  const generateMethodList = () => {
    return (
      ogbAccounts
        ?.filter((item) => item.accountNumber !== 'none')
        .map((item) => {
          return {
            id: item.id,
            name: (
              <>
                <BankIcon /> <Text>{`${item['accountNumber']}`}</Text>
              </>
            ),
            //icon: <BankIcon />,
            description: 'Local Transfer',
            val: item?.id,
          }
        }) || []
    )
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text>Local Transfer</Text>
            </Col>
          </Row>
          <Divider style={{ marginTop: 0 }} />
          <CustomSelect
            type="External Account"
            selected={selectedMethod}
            setSelected={setSelectedMethod}
            list={generateMethodList()}
          />

          <Divider />

          <Collapse activeKey={activeKey} onChange={handleCollapseChange}>
            <CollapsePanel header="Add Local Transfer Account Manually" key="3">
              <>
                <Row gutter={[10, 10]}>
                  <Col span={24}>
                    <Text>Select transfer type</Text>
                  </Col>
                  <Col span={24}>
                    <Select
                      width="100%"
                      placeholder="Select transfer type"
                      value={transactionType}
                      options={[
                        { value: 'EU-instructions', label: 'EU' },
                        { value: 'AU-instructions', label: 'Australia' },
                        { value: 'CA-instructions', label: 'Canada' },
                        { value: 'UK-instructions', label: 'UK' },
                      ]}
                      onChange={(v) => setTransactionType(v)}
                    />
                    <Spacer />
                  </Col>
                </Row>
                <Row gutter={[10, 10]}>
                  <Col span={24}>
                    <DynamicForm
                      fields={generateDynamicFields(getCountryForm(), [])}
                      form={form}
                      onSubmit={onACHSubmit}
                    />
                    <Button block onClick={onACHSubmit}>
                      Add Local Transfer Account Manually
                    </Button>
                  </Col>
                </Row>
              </>
            </CollapsePanel>
          </Collapse>
          <Spacer />
          {/*<Row>
            <Col span={24}>
              <Button
                block
                style={{ backgroundColor: '#FFFFFF', color: '#2d54a4', borderColor: '#2d54a4' }}
                href="https://intercom.help/0xcoast/en/articles/9718227-withdrawing-from-your-coast-account-to-old-glory"
                target="_blank"
              >
                Withdrawal Instructions
              </Button>
            </Col>
          </Row>*/}
        </Col>
      </Row>
    </>
  )
}
